import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Home } from './pages/Home';
import { Legal } from './pages/Legal';
import { Authenticity } from './pages/Authenticity';
import { CrewRewards } from './pages/CrewRewards';
import { Activate } from './pages/Activate';
import { Guide } from './pages/Guide';
import { TrackOrder } from './pages/TrackOrder';
import { ScrollToHash } from './components/ScrollToHash';
import { initPixels } from './utils/tracking';
type OfferId = 'single' | 'trio' | 'crew';
interface AppProps {
  showAnnouncementBar?: boolean;
  defaultOffer?: OfferId;
}
export function App({
  showAnnouncementBar = true,
  defaultOffer = 'trio'
}: AppProps) {
  // Loads the Meta Pixel once and fires PageView as soon as the site loads, on any page.
  useEffect(() => {
    initPixels();
  }, []);
  return <BrowserRouter data-id="element-0" data-mp="28skzynbjv4a8">
      <ScrollToHash data-id="element-1" data-mp="23vciyq2516ak" />
      <Routes data-id="element-2" data-mp="23vunsb2v8su3">
        <Route path="/" element={<Home showAnnouncementBar={showAnnouncementBar} defaultOffer={defaultOffer} data-id="element-4" data-mp="23t8g8bfz6dbv" />} data-id="element-3" data-mp="23u9t8lgjx9w8" />
        <Route path="/verify" element={<Authenticity data-id="element-6" data-mp="3mlayb9n68jv1" />} data-id="element-5" data-mp="3ihv048vgebg8" />
        <Route path="/rewards" element={<CrewRewards data-id="element-8" data-mp="3mjq3rk0ux0x6" />} data-id="element-7" data-mp="3mkhn9wh6j873" />
        <Route path="/activate" element={<Activate data-id="element-10" data-mp="3rbzngibdp4r0" />} data-id="element-9" data-mp="3rc9d24sih9w6" />
        <Route path="/guide" element={<Guide data-id="element-12" data-mp="3relumgucxi8p" />} data-id="element-11" data-mp="3rcsyhvhdegey" />
        <Route path="/track" element={<TrackOrder data-id="element-14" data-mp="4wxfu7a14id" />} data-id="element-13" data-mp="5or2zhbcs60" />
        <Route path="/legal/:slug" element={<Legal data-id="element-16" data-mp="2zl3cjn8vpa6d" />} data-id="element-15" data-mp="56ntiw8hdol" />
        <Route path="*" element={<Legal data-id="element-18" data-mp="2zmeo498kfm81" />} data-id="element-17" data-mp="2zllijblcf2rh" />
      </Routes>
    </BrowserRouter>;
}